import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";

var dateFormat = require("dateformat");

class PlatformEarnings extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div>
          <Image
            className="underprocessImg"
            src={require("../../assets/img/underprocess2.png")}
          />
        </div>
      </div>
    );
  }
}
export default PlatformEarnings;
